export const SituacaoCliente = {
  ATIVO: "Ativo",
  BLOQUEADO: "Bloqueado",
};

export function getStyleSituacaoCliente(situacao) {
  return { background: "#f5f5f5", color: "#333" };
}

export function getStyleFiltroCliente(situacao) {
  return { background: "#f8f9fa", color: "#212529" };
}

export function getTextColorSituacaoCliente(situacao) {
  return "#212529";
}
